module.exports = __webpack_public_path__ + "static/media/button-picture-white.fe35ed06.svg";